import React, { useEffect, useRef, useState } from "react";
import Navbar from "../widgets/Navbar";
import PartnerSidebar from "../widgets/PartnerSidebar";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AreaChartPartner from "../partials/AreaChartPartner";
import toast from "react-hot-toast";
import { useGetAllReferalQuery } from "../../redux/partnerApi";
import { formatDecimal } from "../../util/decimalFormatter";

const PartnerArea = () => {
  const { t } = useTranslation();
  const userDetails = useSelector((state) => state.user);
  const { data: userInfo } = useGetAllReferalQuery();
  const inputRef = useRef(null);
  const [dashboardData, setDashboardData] = useState({
    currentBalance: 0,
    totalReferrals: 0,
    netDeposit: 0,
    netWithdrawal: 0,
    thisMonthReferrals: 0,
    cumulativeClientBalance: 0,
  });

  const handleCopy = () => {
    if (inputRef.current) {
      navigator.clipboard
        .writeText(inputRef.current.value)
        .then(() => {
          toast.success("Link copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    }
  };

  useEffect(() => {
    console.log("userInfo", userInfo);
    if (userInfo?.accountSummary) {
      setDashboardData({
        currentBalance: userInfo.accountSummary.currentBalance || 0,
        totalReferrals: userInfo.accountSummary.totalReferrals || 0,
        netDeposit: userInfo.accountSummary.netDeposit || 0,
        netWithdrawal: userInfo.accountSummary.netWithdrawal || 0,
        thisMonthReferrals: userInfo.accountSummary.thisMonthReferrals || 0,
        cumulativeClientBalance:
          userInfo.accountSummary.cumulativeClientBalance || 0,
      });
    }
  }, [userInfo]);

  return (
    <div>
      <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
            <PartnerSidebar />
            <div className="col-xl-9 col-lg-8">
             
                <h5 className="mb-3">{t("Account Details")}</h5>

                <div className="row">
                  <div className="col-md-5 mb-4">
                    <div className="p-3 p-md-4 bg2 br10 h_100">
                      <div className="d-md-flex al">
                        <p className="mr-auto mb-2">
                          Username: {userDetails?.userData?.user_name}
                        </p>
                      </div>

                      <p className="mr-auto mb-2 mt-4">Your Current Balance</p>
                      <h3>
                        {formatDecimal(dashboardData.currentBalance, 2)} USD
                      </h3>

                      <button className="btn w100 mt-4">
                        Withdraw
                      </button>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="p-3 bg2 br10 h_100">
                          <p className="mb-2">Referrals</p>
                          <h4>{dashboardData.thisMonthReferrals}</h4>{" "}
                          <small>This Month</small>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="p-3 bg2 br10 h_100">
                          <p className="mb-2">Cumulative balance of clients</p>
                          <h4>
                            {formatDecimal(
                              dashboardData.cumulativeClientBalance,
                              2
                            )}
                          </h4>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
              <div className="row row5">
                <div className="col-md-4 col-lg-4  mb-4">
                  <div className="p-3 bg2 br10 h_100">
                    <p className="mb-2">Total Referrals</p>
                    <h4>{dashboardData.totalReferrals}</h4>{" "}
                    {/* Total referrals */}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4  mb-4">
                  <div className="p-3 bg2 br10 h_100">
                    <p className="mb-2">Net Deposit</p>
                    <h4>{dashboardData.netDeposit}</h4> {/* Net deposit */}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4  mb-4">
                  <div className="p-3 bg2 br10 h_100">
                    <p className="mb-2">Net Withdrawal</p>
                    <h4>{dashboardData.netWithdrawal}</h4>{" "}
                    {/* Net withdrawal */}
                  </div>
                </div>
              </div>

              <div className="p-3 bg2 br10 mb-4 text-center position-relative overflow_hidden">
                <AreaChartPartner allData={[]} />
              </div>

              <h5 className="mb-3">{t("Referral Links")}</h5>

              <div className="p-3 p-md-4 bg2 br10 mb-4 text-center position-relative">
                <div className="d-flex mb-3">
                  <h6 className="mr-auto mb-2">Signup</h6>
                </div>
                <div class="position-relative">
                  <input
                    class="form-control"
                    autocomplete="off"
                    type="text"
                    min="0"
                    placeholder="XYZ"
                    disabled
                    ref={inputRef}
                    value={`https://client.luminmarkets.com/register?ref=${userDetails?.userData?.refer_id}`}
                  />
                  <button
                    class="btn position-absolute verification_btn"
                    type="submit"
                    onClick={handleCopy}
                  >
                    Copy Link
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerArea;
